import { Response } from '@marketplace-web/shared/api-client'

import { GetPublicPhotosResp } from '../types/public-photos'

export const transformPublicPhotosResponse = (response: Response<GetPublicPhotosResp>) => {
  return {
    photos: response.photos.map(({ item_id, url }) => ({
      itemId: item_id,
      url,
    })),
  }
}
